function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@chakra-ui/react';
import React from 'react';
export default function SoopIcon(props) {
    return /*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({
        viewBox: "0 0 400 248",
        fill: "currentColor"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M276,24c-29.6,0-56.2,12.9-74.5,33.3c-0.8,0.9-2.1,0.9-2.9,0C180.2,36.9,153.6,24,124,24  C68.8,24,24,68.8,24,124s44.8,100,100,100c29.6,0,56.2-12.9,74.5-33.3c0.8-0.9,2.1-0.9,2.9,0c18.3,20.5,44.9,33.3,74.5,33.3  c55.2,0,100-44.8,100-100S331.2,24,276,24z M276,176c-16,0-29.4-7.7-37.6-16.4c-2.6-2.8-5.8-6.6-9.4-9.8c-1.7-1.5-3.4-2.9-5-4.2  c-6.7-4.8-15-7.6-24-7.6c-9,0-17.3,2.8-24,7.6c-1.6,1.2-3.3,2.6-5,4.2c-3.6,3.2-6.8,7-9.4,9.8C153.4,168.3,140,176,124,176  c-0.4,0-0.8,0-1.2,0c-0.7,0-1.4,0-2.1-0.1c-0.5,0-0.9-0.1-1.4-0.1c-0.3,0-0.6-0.1-0.8-0.1C92.4,173,72,150.9,72,124v0.2  c0-0.2,0-0.3,0-0.4v0.2c0-26.8,20.4-48.9,46.5-51.7c0.3,0,0.6-0.1,0.9-0.1c0.5,0,0.9-0.1,1.4-0.1c0.7,0,1.4-0.1,2.1-0.1  c0.4,0,0.8,0,1.2,0c16,0,29.4,7.7,37.6,16.4c2.6,2.8,5.8,6.6,9.4,9.8c1.7,1.5,3.4,2.9,5,4.2c6.7,4.8,15,7.6,24,7.6s17.3-2.8,24-7.6  c1.6-1.2,3.3-2.6,5-4.2c3.6-3.2,6.8-7,9.4-9.8C246.6,79.7,260,72,276,72c0.4,0,0.8,0,1.2,0c0.7,0,1.4,0,2.1,0.1  c0.4,0,0.9,0.1,1.3,0.1c0.3,0,0.6,0.1,0.9,0.1c25.1,2.7,44.9,23.2,46.4,48.7c0,0.2,0,0.3,0,0.5c0,0.5,0,0.9,0,1.4c0,0.7,0,1.4,0,2.1  c0,0.5,0,1.1,0,1.6c0,0.1,0,0.2,0,0.3c-1.4,25.5-21.2,46.1-46.4,48.8c-0.3,0-0.6,0.1-0.9,0.1c-0.4,0-0.9,0.1-1.3,0.1  c-0.7,0-1.4,0.1-2.1,0.1C276.8,175.9,276.4,176,276,176L276,176z"
        })
    }));
}
